var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',_vm._g(_vm._b({ref:"tabs",class:['menu-tabs', {'menu-tabs-titled': !!_vm.title}],attrs:{"tab-position":"left"}},'el-tabs',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }